// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__rPU_N","active":"MenuItem_active__1hV7E","MenuIcon":"MenuItem_MenuIcon__1vFX1","MenuText":"MenuItem_MenuText__2Zjmu"};